
import { load } from "../../node_modules/@mta/lit-style-loader/stylesToCssArray.js";
import content from "!!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../node_modules/sass-loader/dist/cjs/index.js!./b2b-public-styles.scss";
export default load(content);